/* HeroSpotlightWithRightImage.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["buttonStyles"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _38 = "@media not all and (min-width:30rem){._30wv1h6o{align-items:center}}";
const _37 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _36 = "@media (min-width:64rem) and (max-width:89.99rem){._1p5s1ejb{gap:var(--ds-space-300,24px)}._xut11tz4{min-height:16.5rem}}";
const _35 = "@media (min-width:64rem){._10jx1ccs{max-width:35rem}._1945h0ir{min-height:18.375rem}}";
const _34 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1ejb{gap:var(--ds-space-300,24px)}._1x6l1tz4{min-height:16.5rem}}";
const _33 = "@media (min-width:30rem) and (max-width:47.99rem){._1cj61ejb{gap:var(--ds-space-300,24px)}._1mdb1tz4{min-height:16.5rem}}";
const _32 = "@media not all and (min-width:30rem){._1wm01ejb{gap:var(--ds-space-300,24px)}._8el9idpf{min-height:0}._30wv1h6o{align-items:center}._1sz31h6o{text-align:center}}";
const _31 = "._4cvr1y6m{align-items:flex-start}";
const _30 = "._2lx21bp4{flex-direction:column}";
const _29 = "@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
const _28 = "._tzy4idpf{opacity:0}";
const _27 = "._y44v17nv{animation:fadeIn .5s ease-in-out forwards}";
const _26 = "@media (min-width:64rem) and (max-width:89.99rem){._1p5s1ejb{gap:var(--ds-space-300,24px)}}";
const _25 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1ejb{gap:var(--ds-space-300,24px)}}";
const _24 = "@media (min-width:30rem) and (max-width:47.99rem){._1cj61ejb{gap:var(--ds-space-300,24px)}}";
const _23 = "@media not all and (min-width:30rem){._1wm0pxbi{gap:var(--ds-space-200,1pc)}._1m0a1txw{display:flex}._14q21bp4{flex-direction:column}}";
const _22 = "._1bah1yb4{justify-content:space-between}";
const _21 = "._yv0ewxkt{grid-template-columns:1fr 1fr}";
const _20 = "._1e0c11p5{display:grid}";
const _19 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _18 = "@media (min-width:48rem) and (max-width:63.99rem){._i6jx1k8s{padding-top:1.5rem}._1lh7idpf{padding-right:0}._z3nc1k8s{padding-bottom:1.5rem}._wpaiidpf{padding-left:0}}";
const _17 = "@media (min-width:30rem) and (max-width:47.99rem){._ie1c1k8s{padding-top:1.5rem}._78i2idpf{padding-right:0}._1db01k8s{padding-bottom:1.5rem}._dpmdidpf{padding-left:0}}";
const _16 = "@media not all and (min-width:30rem){._1vlridpf{padding-top:0}._kgiyj3rj{padding-right:3.3rem}._1w0xidpf{padding-bottom:0}._958cj3rj{padding-left:3.3rem}}";
const _15 = "._mezj1osq img{width:100%}";
const _14 = "._1wpz1fhb{align-self:stretch}";
const _13 = "._4cvr1h6o{align-items:center}";
const _12 = "._1bah1h6o{justify-content:center}";
const _11 = "._1e0c1txw{display:flex}";
const _10 = "._4t3i1wug{height:auto}";
const _9 = "._i0dlf1ug{flex-basis:0%}";
const _8 = "._1o9zidpf{flex-shrink:0}";
const _7 = "._16jlkb7n{flex-grow:1}";
const _6 = "._19bv92jo{padding-left:3.9rem}";
const _5 = "._n3td5uys{padding-bottom:.87rem}";
const _4 = "._u5f392jo{padding-right:3.9rem}";
const _3 = "._ca0q5uys{padding-top:.87rem}";
const _2 = "._19pkidpf{margin-top:0}";
const _ = "._1bsb1osq{width:100%}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, xcss } from '@atlaskit/primitives';
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { BodyLarge, Button, EyebrowSmall, H2 } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Animation helper (same as other hero variants)
const fadeInAnimation = null;

// (Spotlight background handled by Carousel now)

const WrapperFlexStyles = null;
const ContentContainerStyle = null;

// Flex styles for the block containing eyebrow, heading and sub-heading
const TextBlockFlexStyles = xcss({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'space.200',
  alignSelf: 'stretch',
  justifyContent: 'center'
});

// Flex styles for heading + subheading container
const HeadingBlockFlexStyles = null;

// Atlaskit CustomThemeButton allows theme override via function
const ctaTheme = (current, themeProps) => {
  const _current = current(themeProps),
    {
      buttonStyles
    } = _current,
    rest = _objectWithoutProperties(_current, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    buttonStyles: _objectSpread(_objectSpread({}, buttonStyles), {}, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '2.5rem',
      minHeight: '2rem',
      padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-300, 24px)"),
      borderRadius: '1.5rem',
      background: "var(--ds-background-brand-bold, #0C66E4)",
      color: "var(--ds-text-inverse, #FFFFFF)",
      transition: 'background 0.2s ease-in-out',
      '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
      },
      '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
      },
      '&:focus-visible': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        outline: "var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border-focused, #388BFF)"),
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
      }
    })
  });
};
const EyebrowText = forwardRef((_ref, __cmplr) => {
  let {
      as: C = EyebrowSmall,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EyebrowText.displayName = 'EyebrowText';
}
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H2,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const SubHeading = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SubHeading.displayName = 'SubHeading';
}
const ImageContainerFlexStyles = xcss({
  display: 'flex',
  flex: '1 0 0',
  alignSelf: 'stretch',
  justifyContent: 'center'
});
const HeroImageContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7, _8, _9, _, _10, _11, _12, _13, _14, _15, _16, _17, _18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0q5uys _u5f392jo _n3td5uys _19bv92jo _16jlkb7n _1o9zidpf _i0dlf1ug _1bsb1osq _4t3i1wug _1e0c1txw _1bah1h6o _4cvr1h6o _1wpz1fhb _mezj1osq _1vlridpf _kgiyj3rj _1w0xidpf _958cj3rj _ie1c1k8s _78i2idpf _1db01k8s _dpmdidpf _i6jx1k8s _1lh7idpf _z3nc1k8s _wpaiidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeroImageContainer.displayName = 'HeroImageContainer';
}
const HeroImageDesktopStyle = null;
const HeroImageStyle = null;
export const HeroSpotlightWithRightImage = _ref5 => {
  let {
    eyebrowText,
    heading,
    subHeading,
    ctaText,
    heroDesktopImage,
    heroTabletImage,
    heroMobileImage,
    redirectUrl,
    onBannerClick,
    onKeyDownBanner: _onKeyDownBanner
  } = _ref5;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20, _21, _13, _14, _, _22, _23, _24, _25, _26]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_zulpxy5q _1e0c11p5 _yv0ewxkt _4cvr1h6o _1wpz1fhb _1bsb1osq _1bah1yb4 _1wm0pxbi _1m0a1txw _14q21bp4 _1cj61ejb _1gzv1ejb _1p5s1ejb"]),
      children: [/*#__PURE__*/_jsx(Show, {
        below: "xs",
        children: /*#__PURE__*/_jsx(HeroImageContainer, {
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_27, _, _28, _29]
            }), /*#__PURE__*/_jsx("img", {
              alt: "",
              src: heroMobileImage,
              className: ax(["_y44v17nv _1bsb1osq _tzy4idpf", "_y44v17nv"])
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_19, _7, _8, _9, _11, _30, _12, _31, _14, _32, _33, _34, _35, _36]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_zulpxy5q _16jlkb7n _1o9zidpf _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _1wpz1fhb _1wm01ejb _8el9idpf _30wv1h6o _1sz31h6o _1cj61ejb _1mdb1tz4 _1gzv1ejb _1x6l1tz4 _10jx1ccs _1945h0ir _1p5s1ejb _xut11tz4"]),
          children: [/*#__PURE__*/_jsxs(Flex, {
            xcss: TextBlockFlexStyles,
            children: [eyebrowText && /*#__PURE__*/_jsx(EyebrowText, {
              children: eyebrowText
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_37, _11, _30, _31, _14, _38]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m _1wpz1fhb _30wv1h6o"]),
                children: [heading && /*#__PURE__*/_jsx(Heading, {
                  children: heading
                }), subHeading && /*#__PURE__*/_jsx(SubHeading, {
                  children: subHeading
                })]
              })]
            })]
          }), redirectUrl && /*#__PURE__*/_jsx(Button, {
            appearance: "primary",
            theme: ctaTheme,
            onClick: e => onBannerClick(e, redirectUrl),
            children: ctaText !== null && ctaText !== void 0 ? ctaText : 'Explore Now'
          })]
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        xcss: ImageContainerFlexStyles,
        children: [/*#__PURE__*/_jsx(Hide, {
          below: "md",
          children: /*#__PURE__*/_jsx(HeroImageContainer, {
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_27, _28, _, _29]
              }), /*#__PURE__*/_jsx("img", {
                alt: "",
                src: heroDesktopImage,
                className: ax(["_y44v17nv _tzy4idpf _1bsb1osq", "_y44v17nv"])
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Show, {
          below: "md",
          children: /*#__PURE__*/_jsx(Hide, {
            below: "xs",
            children: /*#__PURE__*/_jsx(HeroImageContainer, {
              children: /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_27, _, _28, _29]
                }), /*#__PURE__*/_jsx("img", {
                  alt: "",
                  src: heroTabletImage,
                  className: ax(["_y44v17nv _1bsb1osq _tzy4idpf", "_y44v17nv"])
                })]
              })
            })
          })
        })]
      })]
    })]
  });
};